import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=bcee0830&scoped=true&"
import script from "./addModal.vue?vue&type=script&lang=js&"
export * from "./addModal.vue?vue&type=script&lang=js&"
import style0 from "./addModal.vue?vue&type=style&index=0&id=bcee0830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcee0830",
  null
  
)

export default component.exports